import React from 'react';
import PropTypes from 'prop-types';

import ComparisonValue from './comparison-value';

export default function StatComparison({ value, comparisonValue, renderValue, renderComparisonValue, competitiveIndex }) {
  return (
    <>
      <td><span>{renderValue ? renderValue(value) : value}</span></td>
      <ComparisonValue
        value={value}
        comparisonValue={comparisonValue}
        renderComparisonValue={renderComparisonValue}
        competitiveIndex={competitiveIndex}
      />
    </>
  );
}

StatComparison.propTypes = {
  value: PropTypes.number,
  comparisonValue: PropTypes.number,
  renderValue: PropTypes.func,
  renderComparisonValue: PropTypes.func,
  competitiveIndex: PropTypes.bool,
};

StatComparison.defaultProps = {
  value: 0,
  comparisonValue: 0,
  renderValue: null,
  renderComparisonValue: null,
  competitiveIndex: false,
};
